@for (id of regionIds; track id) {
    <ms-colored-icon iconClass="country-icon c{{ id }}" />
}
